module.exports = __webpack_public_path__ + "static/media/huatiao.5351c090.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/huatiao.png
// module id = 1763
// module chunks = 0 1